import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { StoreEnum } from '../../../enums/enums';
import { useStore } from '../../../hooks/store.hook';
import ButtonComponent from '../../button/button.component';
import { theme } from '../../../themes';

const AuthButton = observer(() => {
  const authStore = useStore(StoreEnum.AuthStore);
  const userStore = useStore(StoreEnum.UserStore);
  const navigate = useNavigate();

  const logout = () => {
    authStore.clear();
    navigate('/auth/login');
  };

  const returnToAdmin = () => {
    userStore.clearMasterUser();
    navigate('/admin-indemnizatii-primarie/user-list');
  };

  return (
    <>
      {userStore.masterUser && userStore.user ? (
        <>
          <ButtonComponent
            size="medium"
            variant="outlined"
            sx={{
              ml: 3,
              height: '2.6rem',
              color: theme.palette.primary.main,
              border: `0.1rem solid ${theme.palette.primary.main}!important`
            }}
            onClick={() => returnToAdmin()}
          >
            Intoarce-te in admin
          </ButtonComponent>
        </>
      ) : (
        <>
          {authStore.auth?.token ? (
            <>
              <ButtonComponent
                size="medium"
                variant="outlined"
                sx={{
                  ml: 3,
                  height: '2.6rem',
                  color: theme.palette.primary.main,
                  border: `0.1rem solid ${theme.palette.primary.main}!important`
                }}
                onClick={() => logout()}
              >
                Iesi din cont
              </ButtonComponent>
            </>
          ) : (
            <>
              {/* <ButtonComponent
                        variant="outlined"
                        color="primary"
                        sx={{ mt: 2 }}
                        onClick={() => navigate('/auth/login')}
                      >
                        Intra in cont
                    </ButtonComponent> */}
            </>
          )}
        </>
      )}
    </>
  );
});

export default AuthButton;
